<template>
    <section class="video-block position-relative" :class="{ 'mobile-video-block d-lg-none': this.env == 'mobile', 'd-none d-lg-block': this.env == 'desktop' }">
        <div class="bg-overlay">
            <div class="bg-overlay-content dark">
                <div class="overlay-trigger-icon cursor-pointer size-lg op-ts op-07 bg-light text-dark"
                    data-hover-animate="op-1" data-hover-animate-out="op-07"><i
                        class="bi-play-fill fs-2 position-relative" style="left:1px"></i></div>
            </div>
        </div>
        <video :poster="this.dataImageUrl" class="w-100" style="margin-bottom: -6px;" :controls="this.env == 'desktop' ? true : false" :playsinline="this.env == 'desktop' ? true : false">
            <source :src="this.dataVideoUrl" type="video/mp4">
        </video>
    </section>
</template>

<script>
export default {
    props: ['dataVideoUrl', 'dataImageUrl', 'dataEnv'],
    data() {
        return {
            env: this.dataEnv ? this.dataEnv : 'desktop',
        };
    },
    computed: {
        currentVideo() {
            return '<video controls ' + (this.env == 'desktop' ? 'playsinline' : '') + '><source src="' + this.dataVideoUrl + '" type="video/mp4"></video>';
        },
    },
};
</script>
